import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AccesosRapidoComponent } from '@views/AccesosRapidos/list-accesos-rapido/accesos-rapido.component';

@Component({
  selector: 'app-dashboard-inicio',
  standalone: true,
  imports: [AccesosRapidoComponent,MatCardModule],
  templateUrl: './dashboard-inicio.component.html',
  styleUrl: './dashboard-inicio.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardInicioComponent { }
